import React from "react"

import PageHead from "../components/PageHead"
import Layout from "../components/Layout/index.js"
import WrongPage from "../components/WrongPage"

const index = () => {
  return (
    <>
      <PageHead
        title={"404"}
        description={"Sorry, we couldn't find what you were looking for."}
      />
      <Layout>
        <WrongPage />
      </Layout>
    </>
  )
}

export default index
